module.exports = "/assets/data/182d4d47a191d5e0b3ac02c42243bff0-NG7.data.json";